<template>
  <div v-if="user.isAuthenticated">
    <div
      class="alert text-center"
      :class="[bannerClass]"
      v-if="user.is_fake"
    >
      <div v-if="!enterEmail">
        <span class="mr-3">{{ $t('sentence.unknown_email') }}</span>

        <v-button
          text="phrase.add_email"
          style-type="danger"
          size="sm"
          @click="enterEmail = true"
        />
      </div>
      <form
        v-else-if="!changeMailSent"
        method="post"
        @submit.prevent="sendEmailChangeMail"
      >
        <div
          class="d-flex flex-column flex-md-row justify-content-center align-items-center"
        >
          <span class="mb-3 mb-md-0">
            {{ $t('sentence.fill_in_email') }}:
          </span>
          <div class="mr-0 mr-md-3 mb-3 mb-md-0 w-100 w-md-auto">
            <v-text-input
              size="sm"
              v-model="data.email"
              :required="true"
              type="email"
            />
          </div>

          <div class="w-100 w-md-auto">
            <v-button
              :block="true"
              text="word.send"
              size="sm"
              type="submit"
              :loader="loader"
            />
          </div>
        </div>
      </form>
      <div v-else>
        <i class="fa fa-check mr-2"></i>
        <span v-html="$t('sentence.change_email_link_sent', {email: data.email})"></span>
      </div>
    </div>

    <div
      v-else-if="!user.is_verified"
      class="alert text-center"
      :class="{'alert-success': verificationSent, 'alert-danger': !verificationSent}"
    >
      <div v-if="verificationSent">
        <i class="fa fa-check"></i>
        {{ $t('sentence.verification_email_sent') }}
      </div>
      <div v-else>
        <span class="mr-3">{{ $t('sentence.verify_account') }}</span>
        <v-button
          text="phrase.verify_account"
          style-type="danger"
          size="sm"
          @click="sendVerificationEmail()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/common/components/Button.vue';
import api from '@/common/api';
import TextInput from '@/common/components/inputs/TextInput.vue';

export default {
  name: 'VerifyUserBanner',
  components: {
    'v-button': Button,
    'v-text-input': TextInput,
  },
  data() {
    return {
      enterEmail: false,
      changeMailSent: false,
      verificationSent: false,
      loader: { loading: false },
      data: {
        email: '',
        news_letter: false,
      },
    };
  },
  methods: {
    goToChangeEmail() {
      document.location.href = '/users/change-email/';
    },
    async sendEmailChangeMail() {
      this.loader.loading = true;
      const response = await api.post('email-change-requests/', this.data);
      if (response.status !== 201) {
        this.errors = response.data;
        this.loader.loading = false;
        return;
      }

      this.changeMailSent = true;
    },
    async sendVerificationEmail() {
      await api.post('users/send-verification/');
      this.verificationSent = true;
    },
  },
  computed: {
    ...mapGetters(['user']),
    bannerClass() {
      if (!this.enterEmail) {
        return 'alert-danger';
      }
      if (!this.changeMailSent) {
        return 'alert-warning';
      }
      return 'alert-success';
    },
  },
};
</script>
